import { useUpdate } from '../../../../../../../api/react-query';

export function useEditNoticePeriodAutomationConfig({ id }) {
  const { mutateAsync, isLoading: isEditing } = useUpdate({
    url: 'config/noticePeriod/auto',
    id,
  });

  return {
    editNoticePeriodAutomationConfig: mutateAsync,
    isEditing,
  };
}
